'use strict';

require('lazysizes/plugins/object-fit/ls.object-fit');

require('lazysizes/plugins/parent-fit/ls.parent-fit');

require('lazysizes/plugins/rias/ls.rias');

require('lazysizes/plugins/bgset/ls.bgset');

require('lazysizes');

require('lazysizes/plugins/respimg/ls.respimg');

require('bootstrap/dist/js/bootstrap');

require('../geo_redirection');

require('../../styles/theme.scss');

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _themeA11y = require('@shopify/theme-a11y');

var _themeCart = require('@shopify/theme-cart');

var _cart_function = require('../cart_function');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Common a11y fixes

//import '../../styles/theme.scss.liquid';

(0, _themeA11y.focusHash)();
(0, _themeA11y.bindInPageLinks)();

// Apply a specific class to the html element for browser support of cookies.
// if (cookiesEnabled()) {
//   document.documentElement.className = document.documentElement.className.replace(
//     'supports-no-cookies',
//     'supports-cookies',
//   );
// }
(0, _jquery2.default)(document).ready(function () {

  (0, _jquery2.default)('#logout_click').click(function () {
    // $.cookie('discountCode', "", -1);
    sessionStorage.clear();
  });

  var slideCount = (0, _jquery2.default)('#carousel-banner .carousel-item').length;
  if (slideCount < 2) {
    (0, _jquery2.default)('.carousel-control-prev, .carousel-control-next, .carousel-indicators').hide();
  }

  (0, _jquery2.default)(window).scroll(function () {
    var sticky = (0, _jquery2.default)('.fixed-top, body'),
        scroll = (0, _jquery2.default)(window).scrollTop();

    if (scroll >= 100) sticky.addClass('logo-toggle');else sticky.removeClass('logo-toggle');
  });

  // Ajax Cart action events

  (0, _jquery2.default)('.cart-drawer-action').on("click", function (e) {
    e.preventDefault();
    (0, _jquery2.default)('.cart-drawer, body').addClass('show-drawer');
  });
  (0, _jquery2.default)('.cart-drawer-close').on("click", function (e) {
    e.preventDefault();
    (0, _jquery2.default)('.cart-drawer, body').removeClass('show-drawer');
  });

  (0, _jquery2.default)('.add-to-cart').click(function (e) {
    e.preventDefault();
    debugger;
    var data = (0, _jquery2.default)(this).closest('form[action^="/cart/add"]').serialize();
    console.log('CARTDATA:', data);
    (0, _cart_function.addToCart)(data, 'product');
  });

  (0, _cart_function.cartControls)();
  (0, _cart_function.cartEmptyTemplate)();

  // $(document).on("change", ".qty_count", function() {

  // })
  //  qty +,- functionality
  (0, _jquery2.default)(document).on("click keyup touchstart", ".quantity-minus, .quantity-plus", function () {
    var targetQty = (0, _jquery2.default)(this).closest('.cart-size-quantity').find('.qty_count');

    var new_val = parseInt(targetQty.val(), 10);
    // var product_qty = parseInt($('.qty_count', this).data('available-stock'),10);
    var action = (0, _jquery2.default)(this).is(".quantity-minus") ? -1 : 1;
    new_val = new_val + action;
    // if(new_val !== 0 && new_val <= product_qty){ 
    if (new_val !== 0) {
      targetQty.val(parseInt(new_val));
    }

    // var preFinalQty = oldQty - new_val;
    // var FinalQty = $(this).is(".quantity-minus") ? preFinalQty * 1 : preFinalQty * (-1);
    // FinalQty = parseInt(FinalQty);

    // var qtyVariantID = $(this).closest('.product-grid-item').find(".remove-item p").data("item-id");

    var new_qty = new_val;
    var qtyVariantID = (0, _jquery2.default)(this).closest('.product-grid-item').find(".remove-item p").data("item-id");
    var $this = (0, _jquery2.default)(this).closest('.cart-size-quantity').find('.qty_count');
    // updateItem(new_qty,variantID,$this);
    // if (new_qty == 0) {
    //   $(this).closest('.product-grid-main').remove().fadeIn(200);
    //   QtyChange(new_qty, qtyVariantID, $this);
    // }       
    (0, _cart_function.QtyChange)(new_qty, qtyVariantID, $this);
  });
});

(0, _jquery2.default)(document).ready(function () {
  (0, _jquery2.default)("header .navbar-toggler").on("click", function () {
    (0, _jquery2.default)(this).closest('header').find('.navbar-collapse').toggleClass("show-menu");
    (0, _jquery2.default)("body ").toggleClass("show-menu");
    (0, _jquery2.default)(this).toggleClass("show-menu");
  });
  (0, _jquery2.default)('.overlay').on('click', function () {
    (0, _jquery2.default)("body, header .navbar-toggler, .navbar-collapse, .cart-drawer").removeClass("show-menu show-drawer");
  });
  (0, _jquery2.default)(".product-type-trigger").on("click", function () {
    (0, _jquery2.default)(this).toggleClass("show-dropdown");
  });
});

(0, _jquery2.default)(document).ready(function () {

  var productCart = [];

  function CollectProductObj($this) {
    productCart = [];
    var arrayObj = $this.closest(".products-add-to-cart").find('.product-id');
    (0, _jquery2.default)(arrayObj).each(function () {
      var valArr = (0, _jquery2.default)(this).val();
      var flavour = (0, _jquery2.default)(this).data("flavour");
      productCart.push({
        quantity: 1,
        id: parseInt(valArr),
        properties: {
          'tag': flavour
        }
      });
    });
  }

  function CollectProductObjB($this) {
    productCart = [];
    var arrayObj = $this.closest(".products-add-to-cart").find('.product-id');
    var bobCount = document.getElementById("quantity_b2b_offer_ca").value; //For CA
    //var bobCount = document.getElementById("quantity_b2b_offer").value;  FOR US
    console.log('BOBCount:', bobCount);
    (0, _jquery2.default)(arrayObj).each(function () {
      var valArr = (0, _jquery2.default)(this).val();
      var flavour = (0, _jquery2.default)(this).data("flavour");
      var type = (0, _jquery2.default)(this).data("type");
      console.log(valArr);
      debugger;
      //if(flavour == 'balsam-fir' || type == 'Hypoallergenic')
      if (type == 'Mustache Wax' || type == 'Hypoallergenic') {
        productCart.push({
          quantity: 2,
          id: parseInt(valArr),
          properties: {
            'tag': flavour
          }
        });
      } else if (type == 'Book of Beards') {
        productCart.push({
          quantity: bobCount,
          id: parseInt(valArr),
          properties: {
            'tag': flavour
          }
        });
      } else {
        productCart.push({
          quantity: 3,
          id: parseInt(valArr),
          properties: {
            'tag': flavour
          }
        });
      }
    });
  }
  function CollectProductObjBS($this) {
    productCart = [];
    var arrayObj = $this.closest(".products-add-to-cart").find('.product-id');
    var bobCountSecond = document.getElementById("quantity_b2b_offer-second_ca").value; //FOR CA
    // var bobCountSecond = document.getElementById("quantity_b2b_offer-second").value;  // FOR US
    console.log('BOBCount:', bobCountSecond);
    (0, _jquery2.default)(arrayObj).each(function () {
      var valArr = (0, _jquery2.default)(this).val();
      var flavour = (0, _jquery2.default)(this).data("flavour");
      var type = (0, _jquery2.default)(this).data("type");
      if (type == '100% natural') {
        productCart.push({
          quantity: 2,
          id: parseInt(valArr),
          properties: {
            'tag': flavour
          }
        });
      } else if (type == 'Book of Beards') {
        productCart.push({
          quantity: bobCountSecond,
          id: parseInt(valArr),
          properties: {
            'tag': flavour
          }
        });
      } else {
        productCart.push({
          quantity: 3,
          id: parseInt(valArr),
          properties: {
            'tag': flavour
          }
        });
      }
    });
  }

  function MultiProductCart() {

    _jquery2.default.ajax({
      url: '/cart/add.js',
      type: 'post',
      dataType: 'json',
      data: { items: productCart },
      success: function success(items) {
        console.info(items);
        (0, _cart_function.UpdateCartElements)();
        (0, _cart_function.UpdateCartDraw)();
        (0, _jquery2.default)('.cart-drawer-action')[0].click();
      }
    });
  }

  (0, _jquery2.default)('.multi-cart').on('click', function () {
    var $this = (0, _jquery2.default)(this);
    CollectProductObj($this);
    MultiProductCart();
  });

  (0, _jquery2.default)('.multi-cart-b2b').on('click', function () {

    var $this = (0, _jquery2.default)(this);
    CollectProductObjB($this);
    MultiProductCart();
  });

  (0, _jquery2.default)('.multi-cart-b2b-second').on('click', function () {

    var $this = (0, _jquery2.default)(this);
    CollectProductObjBS($this);
    MultiProductCart();
  });
});

//related product randomly showing two product from collection
(0, _jquery2.default)(".related-product .product-gird-main").css("display", "none");
var divs = (0, _jquery2.default)(".related-product .product-gird-main").get().sort(function () {
  return Math.round(Math.random()) - 0.5; //random so we get the right +/- combo
}).slice(0, 2);
(0, _jquery2.default)(divs).show();

(0, _jquery2.default)('.related-product .product-gird-main:not([style])').remove();

var scrollToId = (0, _jquery2.default)(window.location.hash),
    targetScroll;
if (scrollToId.length) {
  targetScroll = scrollToId.offset().top - 60;
}

(0, _jquery2.default)('html,body').animate({
  scrollTop: targetScroll
});